export const GENERIC_TASK_TYPE_CODE = "G";

const modalTaskTypes = new Set<string>([
  GENERIC_TASK_TYPE_CODE,
  "CSSP",
  "CSSR",
  "SAS",
  "MSADDU",
  "MSADDA",
  "MSADN",
  "MSADA",
  "MSADNAT",
  "MSADAT",
  "CR",
]);

const modalTaskTypeLabels = new Set<string>([
  "Generic",
  "CMS Submission Prep",
  "CMS Submission Review",
  "Sort & Summarization",
]);

const OPS_MODAL_TASK_TYPE_LABEL_BY_CODE: Record<string, string> = {
  [GENERIC_TASK_TYPE_CODE]: "Generic",
  CSSP: "CMS Submission Prep",
  CSSR: "CMS Submission Review",
  SAS: "Sort & Summarization",
};

const OPS_MODAL_TASK_TYPE_CODES = Object.keys(
  OPS_MODAL_TASK_TYPE_LABEL_BY_CODE,
);
const opsModalTaskTypes = new Set<string>(OPS_MODAL_TASK_TYPE_CODES);
const opsModalTaskTypeLabels = new Set<string>(
  Object.values(OPS_MODAL_TASK_TYPE_LABEL_BY_CODE),
);

type TaskTypeOption = { value: string | null; label: string };

/* centralize task type checks used by modal/open-details behavior */
export const isModalTaskType = (taskType: string): boolean =>
  modalTaskTypes.has(taskType);

export const isModalTaskTypeLabel = (taskTypeLabel: string): boolean =>
  modalTaskTypeLabels.has(taskTypeLabel);

export const isOpsModalTaskType = (taskType: string): boolean =>
  opsModalTaskTypes.has(taskType);

export const isOpsModalTaskTypeLabel = (taskTypeLabel: string): boolean =>
  opsModalTaskTypeLabels.has(taskTypeLabel);

/* normalize ops modal task type options from backend constants */
export const getOpsModalTaskTypeOptions = (
  options: TaskTypeOption[] | undefined,
): TaskTypeOption[] => {
  if (!options?.length) {
    return [];
  }

  return OPS_MODAL_TASK_TYPE_CODES.flatMap((code) => {
    const matchingOption = options.find((option) => option.value === code);

    if (!matchingOption) {
      return [];
    }

    return [
      {
        value: matchingOption.value,
        label: OPS_MODAL_TASK_TYPE_LABEL_BY_CODE[code],
      },
    ];
  });
};
